import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import { PERPAY_TERMS_AND_CONDITIONS_URL } from '@perpay-web/fintech/constants/urls';
import { PERPAY_PRIVACY_POLICY_URL } from '@perpay-web/fintech/constants/urls';

export const PhoneDisclosure = ({ className }) => (
    <p className={className}>
        By clicking the button below, you consent to receive automated security
        and account notifications via text message from Perpay. Your mobile
        phone number will not be shared with third parties or affiliates for
        marketing or promotional purposes without your permission. Consent is
        not a condition of purchase. For more information reply HELP. To stop
        receiving texts, reply STOP. Message and data rates may apply. Message
        frequency varies. View our&nbsp;
        <CustomLink
            action='inline-link'
            href={PERPAY_TERMS_AND_CONDITIONS_URL}
            target='_blank'
        >
            Terms and Conditions
        </CustomLink>
        &nbsp;and&nbsp;
        <CustomLink
            action='inline-link'
            href={PERPAY_PRIVACY_POLICY_URL}
            target='_blank'
        >
            Privacy Policy
        </CustomLink>
        .
    </p>
);

export const PhoneDisclosureShorter = ({ className }) => (
    <p className={className}>
        By providing my phone number above, I consent to receive text messages
        from Perpay using automated technology. Consent is not a condition of
        purchase. For HELP reply HELP. To STOP receiving texts reply STOP.
        Message and data rates may apply. View our terms and privacy
        policy&nbsp;
        <CustomLink
            action='inline-link'
            href={PERPAY_TERMS_AND_CONDITIONS_URL}
            target='_blank'
        >
            here
        </CustomLink>
        .
    </p>
);
